import ProductPlaceHolder from './product-placeholder';

export default ProductPlaceHolder;
